module.exports = __webpack_public_path__ + "static/media/accept.f2f20e01.gif";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/accept.gif
// module id = 203
// module chunks = 0